module.exports = __webpack_public_path__ + "static/media/xtm.6601a43c.png";